import React, { useState, useEffect } from 'react';
import { Select, SpaceBetween, Button, Box, Modal } from '@cloudscape-design/components';
import { submissionsApi } from 'api/Submission';

const FrameworkDownloadModal = ({ visible, setVisible }) => {
  const [frameworks, setFrameworks] = useState([]);
  const [selectedFramework, setSelectedFramework] = useState(null);
  const [loading, setLoading] = useState(true);
  const [downloading, setDownloading] = useState(false);

  useEffect(() => {
    const fetchFrameworks = async () => {
      try {
        const data = await submissionsApi.getAllFrameworks();
        const formattedFrameworks = data.map((framework) => ({
          label: framework.title,
          value: framework.id.toString(),
        }));
        setFrameworks(formattedFrameworks);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching frameworks:', error);
        setLoading(false);
      }
    };

    if (visible) {
      fetchFrameworks();
    }
  }, [visible]);
  
  const handleDownload = async () => {
    if (!selectedFramework) return;
    
    setDownloading(true);
    try {
      const { url } = await submissionsApi.downloadFramework(selectedFramework.value);
      window.location.href = url;
      setVisible(false);
    } catch (error) {
      console.error('Error downloading framework:', error);
    } finally {
      setDownloading(false);
    }
  };

  return (
    <Modal
      onDismiss={() => setVisible(false)}
      visible={visible}
      footer={
        <Box float="right">
          <SpaceBetween direction="horizontal" size="xs">
            <Button 
              variant="link" 
              onClick={() => setVisible(false)}
            >
              Cancel
            </Button>
            <Button 
              variant="primary"
              onClick={handleDownload}
              disabled={!selectedFramework || downloading}
              loading={downloading}
            >
              {downloading ? 'Downloading...' : 'Download Framework'}
            </Button>
          </SpaceBetween>
        </Box>
      }
      header="Download Framework"
    >
      <SpaceBetween>
        <Select
          placeholder="Choose a framework to download"
          loadingText="Loading frameworks..."
          statusType={loading ? "loading" : "finished"}
          selectedOption={selectedFramework}
          onChange={({ detail }) => setSelectedFramework(detail.selectedOption)}
          options={frameworks}
        />
      </SpaceBetween>
      <br />
      {selectedFramework && (
        <Box variant="p">
          Selected: {selectedFramework.label}
        </Box>
      )}
    </Modal>
  );
};

export default FrameworkDownloadModal;